import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import type { User } from '@core/account-types';
import { AdminsAvatarsComponent } from '@core/account-ui';
import { I18nService } from '@core/i18n-legacy';

@Component({
  selector: 'rt-candidate-profile-page-online-admins-indicators',
  templateUrl: './online-admins-indicators.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AdminsAvatarsComponent],
})
export class CandidateProfilePageOnlineAdminsIndicatorsComponent {
  private readonly i18n = inject(I18nService);

  public readonly admins = input<User[]>(undefined!);

  constructor() {
    this.renderAdminTooltip = this.renderAdminTooltip.bind(this);
    this.renderOtherAdminsTooltip = this.renderOtherAdminsTooltip.bind(this);
  }

  public renderAdminTooltip(admin: User): string {
    return this.i18n.translate('app.candidate.online_admins_indicators.admin_tooltip', {
      adminName: [admin.firstName, admin.lastName].filter(Boolean).join(' '),
    });
  }

  public renderOtherAdminsTooltip(admins: User[]): string {
    return this.i18n.translate('app.candidate.online_admins_indicators.other_admins_tooltip', {
      adminsCount: admins.length,
      adminsNames: admins
        .map(admin => [admin.firstName, admin.lastName].filter(Boolean).join('&nbsp'))
        .join(', '),
    });
  }
}
